import React from 'react';
import _ from 'lodash';
import moment from 'moment';

// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  FormGroup,
  Form,
  CardBody,
  InputGroup,
  Input,
  Modal,
  Button, Badge, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';
import { axiosGet, axiosPost } from 'util/apiConfig.js';
import {databaseTimeFormat, dateForPaymentListing} from "../../util/constance";
import io from 'socket.io-client';
import "./messages.css";
import classnames from "classnames";
import styles from "./SalesNotification.css";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import Select from "react-select";
import {Device} from "@twilio/voice-sdk";
import {CopyToClipboard} from "react-copy-to-clipboard";

const USER_STATE = {
  CONNECTING : "Connecting",
  READY : "Ready",
  ON_CALL : "On call",
  OFFLINE : "Offline",
}

// Attachments render as a fixed-size thumbnail; the real file opens in the
// lightbox, so a big image or PDF never blows out the chat bubble.
const ATTACHMENT_THUMB_STYLE = {
  width: '120px',
  height: '120px',
  borderRadius: '6px',
  border: '1px solid #e0e0e0',
  background: '#f1f3f5',
  overflow: 'hidden',
  position: 'relative',
  cursor: 'pointer',
};

const ATTACHMENT_FILE_THUMB_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  padding: '8px',
};

const ATTACHMENT_THUMB_LABEL_STYLE = {
  fontSize: '11px',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'center',
};

const ATTACHMENT_PLAY_BADGE_STYLE = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '38px',
  height: '38px',
  borderRadius: '50%',
  background: 'rgba(0,0,0,0.55)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
};

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      attachmentPreview: null,
      userId: '',
      lastReadMessageId: [],
      userName: '',
      activeTab: "1",
      classList: [],
      sectionList: [],
      sectionId: '',
      emailContent: '',

      receivedMessages: [],
      allMessages: [],
      chatMessages: [],
      textMessageList: [],
      voiceMessageList: [],
      messageLoader: false,
      textMessage: '',
      msgClass: '',
      msgClassError: false,
      textMesageError: false,
      selectedMessage: {},
      unreadMessageList: [],

      listPage: 1,
      totalListPage: '',
      rowLimit: 10,
      classId: '',
      mobileNumber: '',
      email: '',
      subject: 'This is Subject',

      fileUploaded: '',

      modalTitle: '',
      successModal: false,
      errorModal: false,
      teacherName: '',
      message: '',
      editModal: false,
      addModal: false,
      replyModal: false,
      showVideoModal: false,
      to: '',
      messageReply: '',
      replyMessageError: false,
      selectedMessageId: '',
      userState: USER_STATE.OFFLINE,
      notificationCallModal: false,
      messageStates: {},
      selectedClassId: '',
      selectedSectionClassId: '',
      sectionChatText: '',
      sectionChatSending: false,
      // Phone layout: show the open conversation instead of the list.
      mobileThreadOpen: false,
    };
  }

  componentDidMount() {
    // iPhone browsers have no Notification outside home-screen apps.
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
    let storage = localStorage.getItem('Sanga_Admin');
    storage = storage ? JSON.parse(storage) : null;
    const socket = io(process.env.REACT_APP_SOCKET)
    socket.on('connection', ()=>console.log(socket.id))
    socket.on('message', function(data) {
      // Refresh first: a failed notification (e.g. on Android) must not stop updates.
      this.getAllReceivedMessages();
      const { selectedMessage } = this.state;
        if (selectedMessage) {
            this.getAllTwilioReceivedMessageUsers(selectedMessage);
        }
      this.showNotification();
    }.bind(this));
    this.setState(
      {
        userId: (storage && storage.userId) || '',
        userName: '',
        newRequestList: [],
        allMessages: [],
      },
      () => {
        this.getClass();
        this.getVoiceMessage();
        this.getAllSectionsWithLatestMessage();
        this.getAllReceivedMessages();
        setInterval(() => {
          this.getAllSectionsWithLatestMessage();
        }, 3600000);
      }
    );
  }

  callInit = (sale, index) => {
    axiosPost('sales/token', {})
        .then((response) => {
          if (!response.isError) {
            this.setState(
                {
                  loading: false
                },
                () => {
                  const token = response.data.token;
                  const device = new Device(token, {
                    logLevel: 1,
                    codecPreferences: ["opus", "pcmu"],
                  });
                  device.register();
                  this.setState({device})
                  device.addListener("connect", (device) => {
                    console.log("Connect event listener added .....");
                    return device;
                  });
                  device.on("registered", () => {
                    console.log("Agent registered");
                    this.setState({userState: USER_STATE.READY});
                  });
                  device.on("connect", (connection) => {
                    console.log("Call connect");
                    this.setState({userState: USER_STATE.ON_CALL})
                  });
                  device.on("disconnect", () => {
                    console.log("Disconnect event");
                    this.setState({userState: USER_STATE.READY})
                  });

                  setTimeout(()=>{
                    this.handleCall(sale, index)
                  }, 1000)

                  return () => {
                    device.destroy();
                    this.setState({device: undefined})
                    this.setState({userState: USER_STATE.OFFLINE})
                  };
                }
            );
          } else {
            this.setState({
              loading: false,
              errorModal: true,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            modalTitle: 'Sorry!',
            message: 'Something is wrong. Try again later.',
          });
          console.log(error);
        });
  }

  getClass = () => {
    // API --
    axiosGet(`class/get-classes-list`)
        .then((response) => {
          if (!response.isError) {
            this.setState({
              classList: response.data || [],
            });
          } else {
            this.setState({
              classList: [],
            });
          }
        })
        .catch((error) => {
          this.setState({
            classList: [],
          });
        });
  };

  getVoiceMessage = () => {
    // API --
    axiosGet(`sales/get-sales-followup-voice-message`)
        .then((response) => {
          if (!response.isError) {
            const sanitizedList = (response.data || []).map((item) => {
              if (item.mobile) {
                return {
                  ...item,
                  mobile: item.mobile.replace(/^(\+1)+/, '+1'),
                };
              }
              return item;
            });
            this.setState({
              voiceMessageList: sanitizedList,
            });
          } else {
            this.setState({
              voiceMessageList: [],
            });
          }
        })
        .catch((error) => {
          this.setState({
            voiceMessageList: [],
          });
        });
  };

  showNotification = () => {
    // Check if the browser supports notifications
    if (!('Notification' in window)) {
      console.log('Notifications not supported in this browser');
      return;
    }

    // Check if permission has been granted for notifications
    if (Notification.permission !== 'granted') {
      console.log('Permission not granted for notifications');
      return;
    }

    try {
      // Create a new notification
      new Notification('New Notification', {
        body: 'This is a notification',
      });

      // Play a sound
      const audio = new Audio('/audio/iphone_sound.mp3');
      const played = audio.play();
      if (played && played.catch) played.catch(() => {});
    } catch (e) {
      console.log('Notification could not be shown', e);
    }
  };

  getAllSectionsWithLatestMessage = () => {
    axiosGet(`message/get-all-section-with-latest-message`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            allMessages: response.data,
          });
        } else {
          this.setState({
            allMessages: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessages: [],
        });
        console.log(error);
      });
  }

  getLastUnreadMessageId = () => {
    axiosGet(`message/get-message-last-unread-id`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            lastReadMessageId: response?.data[0]?.sid || '',
          });
        } else {
          this.setState({
            lastReadMessageId: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          lastReadMessageId: [],
        });
      });
  }
  getAllMessageBySectionId = (sectionId, teacherName, sectionClassId) => {
    // Switching conversation: clear the old messages so they never show under the new name.
    const switching = sectionId !== this.state.selectedMessageId;
    this.setState({
      selectedMessageId: sectionId,
      selectedSectionClassId: sectionClassId !== undefined ? sectionClassId : this.state.selectedSectionClassId,
      ...(switching ? { chatMessages: [] } : {}),
    })
    const { allMessages } = this.state;
    axiosGet(`message/get-all-message-section-by-id/${sectionId}`)
      .then((response) => {
        // A late response for a conversation that is no longer open is ignored.
        if (this.state.selectedMessageId !== sectionId) return;
        if (!response.isError) {
          this.setState({
            teacherName: teacherName,
            chatMessages: response.data,
          });
          this.updateSystemMessageRead( sectionId);
        } else {
          this.setState({
            chatMessages: [],
          });
        }
      })
      .catch((error) => {
        if (this.state.selectedMessageId !== sectionId) return;
        this.setState({
          chatMessages: [],
        });
      });
  }

  getAdminUserId = () => {
    if (this.state.userId) return this.state.userId;
    try {
      const storage = JSON.parse(localStorage.getItem('Sanga_Admin'));
      return (storage && storage.userId) || '';
    } catch (e) {
      return '';
    }
  }

  sendSectionChatMessage = () => {
    const { sectionChatText, selectedMessageId, selectedSectionClassId, teacherName } = this.state;
    const message = (sectionChatText || '').trim();
    if (!message || !selectedMessageId || this.state.sectionChatSending) return;
    const userId = this.getAdminUserId();
    if (!userId) {
      alert('Could not identify your admin user. Please log out and log back in, then try again.');
      return;
    }
    this.setState({ sectionChatSending: true });
    axiosPost('message/add-message', {
      userId,
      sectionId: selectedMessageId,
      classId: selectedSectionClassId || '',
      message,
    })
      .then((response) => {
        this.setState({ sectionChatSending: false });
        if (!response.isError) {
          this.setState({ sectionChatText: '' });
          this.getAllMessageBySectionId(selectedMessageId, teacherName);
          this.getAllSectionsWithLatestMessage();
        } else {
          alert(response.message || 'Message could not be sent.');
        }
      })
      .catch(() => {
        this.setState({ sectionChatSending: false });
        alert('Message could not be sent.');
      });
  }

  sendSectionChatFile = (event) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = '';
    const { selectedMessageId, selectedSectionClassId, teacherName } = this.state;
    if (!file || !selectedMessageId || this.state.sectionChatSending) return;
    const isVideo = /\.(mp4|mov|webm)$/i.test(file.name || '');
    const maxBytes = isVideo ? 50 * 1024 * 1024 : 10 * 1024 * 1024;
    if (file.size > maxBytes) {
      alert(`File is too large. Maximum size is ${isVideo ? '50MB' : '10MB'}.`);
      return;
    }
    const userId = this.getAdminUserId();
    if (!userId) {
      alert('Could not identify your admin user. Please log out and log back in, then try again.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('classId', selectedSectionClassId || '');
    formData.append('sectionId', selectedMessageId);
    this.setState({ sectionChatSending: true });
    axiosPost('message/upload-file-for-message-admin', formData, true)
      .then((response) => {
        this.setState({ sectionChatSending: false });
        if (!response.isError) {
          this.getAllMessageBySectionId(selectedMessageId, teacherName);
          this.getAllSectionsWithLatestMessage();
        } else {
          alert(response.message || 'Attachment could not be sent.');
        }
      })
      .catch(() => {
        this.setState({ sectionChatSending: false });
        alert('Attachment could not be sent.');
      });
  }

  getAllTwilioReceivedMessageUsers = (from, sid) => {
    // Switching conversation: clear the old messages so a reply never goes to the wrong number.
    const switching = from !== this.state.selectedMessage;
    this.setState({ selectedMessage: from, ...(switching ? { textMessageList: [] } : {}) })
    const { lastReadMessageId } = this.state;
    axiosGet(`message/get-all-twilio-received-message-users/${from}`)
      .then((response) => {
        // A late response for a number that is no longer open is ignored.
        if (this.state.selectedMessage !== from) return;
        if (!response.isError) {
          this.setState({
            textMessageList: response.data,
          });
          this.updateMessageServiceId( [sid,...lastReadMessageId]);
          this.setState({lastReadMessageId: [sid,...lastReadMessageId]})
        } else {
          this.setState({
            textMessageList: [],
          });
        }
      })
      .catch((error) => {
        if (this.state.selectedMessage !== from) return;
        this.setState({
          textMessageList: [],
        });
      });
  }

  updateMessageServiceId = (sid) => {
    axiosPost(`message/update-message-last-unread-id`, {sid})
      .then((response) => {
        if (!response.isError) {
        }
      })
      .catch((error) => {

      });
  }

  updateSystemMessageRead = (sectionId) => {
    const { allMessages } = this.state;
    axiosPost(`message/update-message-status`, {sectionId})
      .then((response) => {
        if (!response.isError) {
          const index = allMessages.findIndex((item) => item.sectionId === sectionId);
          allMessages[index].latestMessage.adminRead = true;
          this.setState({allMessages});
        }
      })
      .catch((error) => {

      });
  }

  // to get all messages -
  getAllMessages = () => {
    const { listPage, rowLimit } = this.state;
    // API -
    axiosGet(`message/get-all-message/${listPage}/${rowLimit}`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            allMessages: response.data?.result,
            totalNewPage: response.data?.noofpage,
          });
        } else {
          this.setState({
            allMessages: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          allMessages: [],
        });
        console.log(error);
      });
  };

  getAllReceivedMessages = () => {
    this.setState({messageLoader: true})
    axiosGet(`message/get-all-twilio-received-message`)
      .then((response) => {
        if (!response.isError) {
          this.setState({
            messageLoader: false,
            receivedMessages: response.data,
          });
          this.getLastUnreadMessageId();
        } else {
          this.setState({
            messageLoader: false,
            receivedMessages: [],
          });
        }
      })
      .catch((error) => {
        this.setState({
          messageLoader: false,
          receivedMessages: [],
        });
        console.log(error);
      });
  };



  replyMessageResponse = () => {
    const { selectedMessage } = this.state;
    let { replyMessage, loading } = this.state;
    if(!replyMessage || replyMessage == ''){
      return alert('Please enter reply message');
    }
    if (replyMessage && !loading) {
      this.setState({ loading: true });
      let dataToSend = {
       message: replyMessage,
       to: selectedMessage,
       classId: this.state.classId
      };
      // API -
      axiosPost('message/send-reply', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.getAllTwilioReceivedMessageUsers(selectedMessage);
            this.setState(
              {
                loading: false,
                successModal: true,
                modalTitle: 'Success',
                message: 'Successfully added',
                replyMessage: '',
                to: '',
              },
              () => {
              }
            );
          } else {
            this.setState({
              loading: false,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
              replyMessage: '',
              to: '',
              replyMessageError: false,
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            message: 'Something is wrong. Try again later.',
            replyMessage: '',
            to: '',
          });
        });
    }
  };

  changePage = (status) => {
    if (status && status === 'next') {
      this.setState({ listPage: this.state.listPage + 1 }, () =>
        this.getAllMessages()
      );
    } else if (status && status === 'prev') {
      this.setState({ listPage: this.state.listPage - 1 }, () =>
        this.getAllMessages()
      );
    }
  };

  // for redirecting to teacher's profile -
  viewMessage = (index) => {
    let { allMessages } = this.state;
    let selectedMessage = allMessages[index];
    if (selectedMessage && selectedMessage.messageType == 'MESSAGE') {
      this.setState({
        selectedMessage: selectedMessage,
        textMessage: selectedMessage.message,
        editModal: true,
      });
    } else if (selectedMessage && selectedMessage.messageType == 'FILE') {
      // console.log("video modal selected");
      this.setState({
        showVideoModal: true,
        selectedMessage: selectedMessage,
      });
    }
  };

  // Modal control -
  toggleModal = (state) => {
    if (state == 'editModal') {
      this.setState({
        [state]: !this.state[state],
        selectedMessage: {},
        textMessage: '',
      });
    } else if (state == 'addModal') {
      this.setState({
        [state]: !this.state[state],
        textMessage: '',
        msgClass: '',
        textMesageError: false,
        msgClassError: false,
      });
    } else if (state == 'addReply') {
      this.setState({
        [state]: !this.state[state],
        to: '',
        replyMessage: '',
      });
    } else {
      this.setState({
        [state]: !this.state[state],
        modalTitle: '',
        message: '',
      });
    }
  };

  getAllSections = () => {
    const { classId } = this.state;
    this.setState({ loading: false });
    axiosGet(`section/get-sections-dropdown/${classId}`)
        .then((response) => {
          if (!response.isError) {
              this.setState({ loading: false, sectionList: response.data });
          } else {
            this.setState({ loading: false });
          }
        })
        .catch((error) => {
          console.log(error);
        });
  };


  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        mobileThreadOpen: false,
      });
    }
  };

  sendMessageByText = () => {
    const {email, mobileNumber, emailContent, classId, sectionId, subject} = this.state;
    if(!email || !mobileNumber || !emailContent || !classId || !sectionId || !subject){
      return alert('Please enter all fields');
    }
    const dataToSend = {
        email,
        mobileNumber,
        message:emailContent,
        classId,
        sectionId,
        subject
    }
    axiosPost('message/send-email-message', dataToSend)
        .then((response) => {
          if (!response.isError) {
            this.setState(
                {
                  loading: false,
                  successModal: true,
                  modalTitle: 'Success',
                  message: 'Successfully added',
                  email: '',
                  mobileNumber: '',
                  emailContent: '',
                  sectionId: null,
                  subject: '',
                  sectionList: [],
                },
                () => {
                }
            );
          } else {
            this.setState({
              loading: false,
              modalTitle: 'Sorry!',
              message: 'Something is wrong. Try again later.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorModal: true,
            message: 'Something is wrong. Try again later.',
          });
        });
  }

  setSectionDetail = () => {
    const { sectionId } = this.state;
    const section = this.state.sectionList.find((item) => item.sectionId === sectionId);
    this.setState({
        mobileNumber: section?.mobileNumber,
        email: section?.email
    })
  };

  isTimeInRange(timezone) {
    const now = new Date();
    const userTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: timezone }).format(now);
    const hour = parseInt(userTime, 10);

    // Check if the time is between 8 AM (8) and 9 PM (21)
    return hour >= 8 && hour < 21;
  }

  rejectCall = ()=>{
    const {device, selectedNumber} = this.state
    device.emit("disconnect");
    device.emit("cancel");
    device.emit("reject");
    device.disconnectAll({params: {To: selectedNumber} });
  }

  handleCall = async (sale, index) => {
    const confirm = window.confirm(`Are you sure want to call? \nPlease verify details,\nMobile: ${sale.mobile}, `)
    if(!confirm){
      return false;
    }
    const {device, userType } = this.state;
    device.emit("connect");
    device.connect({params: {To: sale.mobile, userType, classId: sale.classId } }).then((call) => {
      call.on("accept", () => {
        this.updateMessageState(index, USER_STATE.ON_CALL);
        console.log("call accepted");
      });
      call.on("disconnect", () => {
        console.log("The call has been disconnected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
      call.on("reject", () => {
        console.log("The call was rejected.");
      });
      call.on("cancel", () => {
        console.log("The call was rejected.");
        this.updateMessageState(index, USER_STATE.READY);
      });
    })
  };

  updateMessageState = (index, newState) => {
    this.setState(prevState => ({
      messageStates: {
        ...prevState.messageStates,
        [index]: newState
      }
    }));
  };

  clientConnect = (index) => {
    let { voiceMessageList } = this.state;
    let selectedNotification = voiceMessageList[index];
    this.setState({
      notificationCallModal: true,
      selectedNumber: selectedNotification.mobile || '',
      selectedClassId: selectedNotification.classId || ''
    });
  };

  replyMessageResponses = () => {
    let confirm = window.confirm('Are you sure want send message?');
    if (confirm) {
      let { twillioMessage, loading, selectedNumber } = this.state;
      if(!twillioMessage || twillioMessage == ''){
        return alert('Please enter message');
      }
      if (twillioMessage && !loading) {
        this.setState({ loading: true });
        let dataToSend = {
          message: twillioMessage,
          to: `${selectedNumber}`,
          classId: this.state.selectedClassId
        };
        // API -
        axiosPost('message/send-reply', dataToSend)
            .then((response) => {
              if (!response.isError) {
                this.setState(
                    {
                      loading: false,
                      notificationCallModal: false,
                      twillioMessage: '',
                      selectedNumber: '',
                    },
                    () => {
                    }
                );
              } else {
                this.setState({
                  loading: false,
                  modalTitle: 'Sorry!',
                  message: 'Something is wrong. Try again later.',
                  notificationCallModal: false,
                  twillioMessage: '',
                  selectedNumber: '',
                });
              }
            })
            .catch((error) => {
              this.setState({
                loading: false,
                errorModal: true,
                message: 'Something is wrong. Try again later.',
                notificationCallModal: false,
                twillioMessage: '',
                selectedNumber: '',
              });
            });
      }
    }
  };

  // Phone only (hidden from md up): back to the list, who the conversation is with, and links.
  renderMobileThreadHeader = (title, subtitle, dashboardUrl) => (
    <div className='msg-mobile-header d-md-none'>
      <Button size='sm' color='secondary' type='button' onClick={() => this.setState({ mobileThreadOpen: false })}>
        &larr; Back
      </Button>
      <div className='msg-mobile-title'>
        <div className='font-weight-bold'>{title}</div>
        <small className='text-muted'>
          {subtitle}
          {dashboardUrl && (
              <> &middot; <a href={dashboardUrl} target='_blank' rel='noopener noreferrer'>Open dashboard</a></>
          )}
        </small>
      </div>
    </div>
  );

  render() {
    let {
      allMessages,
      successModal,
      errorModal,
      modalTitle,
      message,
      classList,
      sectionList,
      sectionId,
      receivedMessages,
      replyMessage,
      chatMessages,
      selectedMessageId,
      textMessageList,
      activeTab,
      selectedMessage,
      messageLoader,
      lastReadMessageId,
      teacherName,
      classId,
      mobileNumber,
      email,
      subject,
      voiceMessageList,
      notificationCallModal,
      twillioMessage,
      emailContent,
      loading,
      mobileThreadOpen

    } = this.state;
    const isUnread= allMessages.find((message) => message?.latestMessage?.adminRead === false);
    const splitClass = classnames('row msg-split', { 'msg-thread-open': mobileThreadOpen });
    const openSms = typeof selectedMessage === 'string'
      ? (receivedMessages || []).find((m) => m.from === selectedMessage)
      : null;
    const openSection = (allMessages || []).find((m) => m.sectionId === selectedMessageId);
    return (
      <div className='message-page'>
        <Header />
          <Nav tabs>
            <NavItem>
              <NavLink
                  className={classnames({ active: activeTab === '1' }, styles.navLink)}
                  onClick={() => {
                    this.toggle("1");
                  }}>
                Text Messages
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                  className={classnames({ active: activeTab === '2' }, styles.navLink)}
                  onClick={() => {
                    this.toggle("2");
                  }}
              >
                { isUnread
                     && (
                        <i style={{color: 'red', marginRight: '2px', fontSize: 'small' }} className="fa fa-circle"></i>
                    )
                }
              System Messages
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                  className={classnames({ active: activeTab === '3' }, styles.navLink)}
                  onClick={() => {
                    this.toggle("3");
                  }}>
                Send Messages
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                  className={classnames({ active: activeTab === '4' }, styles.navLink)}
                  onClick={() => {
                    this.toggle("4");
                  }}>
                Voice Messages
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Container fluid>
                <Row >
                  <div className='col'>
                    <Card className='shadow' >
                      <CardHeader className='border-0'>
                      </CardHeader>
                      <div className={splitClass}>
                        <div className="list-view msg-list-pane">
                          <h2>Sections</h2>

                          <ul >
                            {!messageLoader && receivedMessages.length ?
                                receivedMessages.map((value, index) => {
                                  const isExist = lastReadMessageId.includes(value.sid);
                                  return (
                                      <>
                                        <li key={index}
                                            onClick={() => {
                                              this.setState({ mobileThreadOpen: true });
                                              this.getAllTwilioReceivedMessageUsers(value?.from, value?.sid);
                                            }}
                                            style={{
                                              backgroundColor: value?.from === selectedMessage ? 'rgb(186 215 229)' : 'white',
                                            }}
                                        >
                                          <div className="message-container">
                                            {
                                              !isExist && (
                                                    <i style={{color: 'red', marginRight: '2px', fontSize: 'small' }} className="fa fa-circle"></i>
                                                )
                                            }
                                            <span className="message">{value.from} <span>
                                              {
                                                value?.sectionName ? (
                                                            <a
                                                                href={`https://fiverkids.com/userdashboardpreview/${value.publicUserUrl}`}
                                                                target={'_blank'}
                                                            >
                                                              {value.sectionName}
                                                            </a>
                                                  ): 'Trial'
                                              }</span>  </span>
                                            <br/>
                                            <a className="message-link">{value.body}</a>
                                          </div>

                                        </li>
                                      </>
                                  )
                                }):
                                <><a>Loading....</a></>
                            }
                          </ul>
                        </div>

                        <div className="message-list col msg-thread-pane">
                          {this.renderMobileThreadHeader(
                              typeof selectedMessage === 'string' ? (
                                  <a href={`tel:${selectedMessage}`}><i className='fa fa-phone mr-1' />{selectedMessage}</a>
                              ) : null,
                              openSms?.sectionName || 'Trial',
                              openSms?.sectionName && openSms?.publicUserUrl
                                  ? `https://fiverkids.com/userdashboardpreview/${openSms.publicUserUrl}`
                                  : null
                          )}
                          <div className="msg-thread-body">
                            {textMessageList &&
                                textMessageList.map((value, index) => {
                                  const float = value?.direction == 'outbound-api' ? 'right' : 'left';
                                  const color = value?.direction == 'outbound-api' ? '#f8cfcf' : '#c4e1ea';
                                  return (
                                      <>
                                        <div
                                            key={index}
                                            style={{
                                              backgroundColor: color,
                                              padding: '10px',
                                              marginBottom: '10px',
                                              borderRadius: '8px',
                                              float: float,
                                              clear: 'both',
                                            }}
                                            className='msg-bubble'
                                        >
                                          <div>
                                            {value.body ? (
                                                <span style={{fontWeight: 'bold', fontStyle: 'initial', fontSize: 'large'}}>{value.body}</span>
                                            ) : null}
                                            {Array.isArray(value.media) && value.media.map((md, mi) => {
                                              const ct = md.contentType || '';
                                              if (ct.indexOf('image/') === 0) {
                                                return (
                                                    <img
                                                        key={mi}
                                                        src={md.url}
                                                        alt='attachment'
                                                        title='Click to preview'
                                                        onClick={() => this.setState({ attachmentPreview: { url: md.url, type: 'image', name: 'attachment' } })}
                                                        style={{ maxWidth: '220px', maxHeight: '220px', borderRadius: '6px', display: 'block', marginTop: '4px', cursor: 'pointer' }}
                                                    />
                                                );
                                              }
                                              if (ct.indexOf('video/') === 0) {
                                                return (
                                                    <video
                                                        key={mi}
                                                        src={md.url}
                                                        title='Click to preview'
                                                        onClick={() => this.setState({ attachmentPreview: { url: md.url, type: 'video', name: 'video attachment' } })}
                                                        style={{ maxWidth: '220px', maxHeight: '220px', borderRadius: '6px', display: 'block', marginTop: '4px', cursor: 'pointer' }}
                                                    />
                                                );
                                              }
                                              return (
                                                  <span
                                                      key={mi}
                                                      role='button'
                                                      onClick={() => this.setState({ attachmentPreview: { url: md.url, type: 'file', name: 'attachment' } })}
                                                      style={{ display: 'block', marginTop: '4px', fontWeight: 'bold', cursor: 'pointer' }}
                                                  >
                                                    <i className='fa fa-paperclip' style={{ marginRight: '6px' }} />Attachment
                                                  </span>
                                              );
                                            })}
                                          </div>
                                          <div style={{ marginTop: '5px' }}>
                                            <span>{moment(value.dateCreated).format(dateForPaymentListing)}</span>
                                            <span>&nbsp;{moment(value.dateCreated).format(databaseTimeFormat)}</span>
                                          </div>
                                        </div>
                                      </>
                                  )
                                })
                            }
                          </div>
                        { textMessageList && textMessageList.length > 0 && (
                            <div className='msg-composer' style={{ display: 'flex', justifyContent: 'end', marginRight: '5px' }}>
                              <Input
                                  placeholder='Message'
                                  type='text'
                                  name='className'
                                  className='msg-reply-input'
                                  value={replyMessage}
                                  onChange={(e) =>
                                      this.setState({
                                        replyMessage: e.target.value,
                                        replyMessageError: false,
                                      })
                                  }
                              />
                              <Button
                                  color='primary'
                                  type='button'
                                  onClick={() => this.replyMessageResponse()}
                              >
                                Send
                              </Button>
                            </div>
                        )}
                        </div>
                      </div>
                    </Card>
                  </div>
                </Row>
              </Container>
            </TabPane>
            <TabPane tabId='2'>
                <Container fluid>
                  <Row >
                    <div className='col'>
                      <Card className='shadow' >
                        <CardHeader className='border-0'>
                          <h3 className='mb-0'>All Messages</h3>
                        </CardHeader>
                        <div className={splitClass}>
                          <div className="list-view msg-list-pane">
                            <h2>Sections</h2>
                            <ul >
                              {allMessages &&
                                  allMessages.map((value, index) => {
                                    return (
                                        <>
                                          <li key={index} onClick={() => {
                                                this.setState({ mobileThreadOpen: true });
                                                this.getAllMessageBySectionId(value?.sectionId, value?.teacherName, value?.classId || '');
                                              }}
                                              style={{
                                                backgroundColor: value?.sectionId === selectedMessageId ? 'rgb(186 215 229)' : 'white',
                                              }}
                                          >
                                            <div className="message-container">
                                              {
                                                  value?.latestMessage?.adminRead === false && (
                                                      <i style={{color: 'red', marginRight: '2px', fontSize: 'small' }} className="fa fa-circle"></i>
                                                  )
                                              }
                                                  <a
                                                      href={`https://fiverkids.com/userdashboardpreview/${value.publicUserUrl[0].publicUrl}`}
                                                      target={'_blank'}
                                                  ><span>{value?.name || ''}</span></a>
                                              <br/>
                                              <a className="message-link">{value?.latestMessage?.message || ''}</a>
                                            </div>
                                          </li>
                                        </>
                                    )
                                  })
                              }
                            </ul>
                          </div>
                          <div className="message-list col msg-thread-pane">
                            {this.renderMobileThreadHeader(
                                openSection?.name || '',
                                openSection?.teacherName ? `Teacher: ${openSection.teacherName}` : '',
                                openSection?.publicUserUrl?.[0]?.publicUrl
                                    ? `https://fiverkids.com/userdashboardpreview/${openSection.publicUserUrl[0].publicUrl}`
                                    : null
                            )}
                            <div className='msg-roles'>
                              <h2 className={'float-left'}>Student</h2>
                              <h2 className={'float-right'} style={{marginRight: '20px'}}>Teacher
                                {teacherName && (
                                    <span style={{marginLeft: '10px'}}>: {teacherName}</span>
                                )}

                              </h2>
                            </div>
                            <div className="msg-thread-body">
                              {chatMessages &&
                                  chatMessages.map((value, index) => {
                                    const isOwnSide = value?.userType == 'teacher' || value?.userType == 'admin';
                                    const float = isOwnSide ? 'right' : 'left';
                                    const color = value?.userType == 'admin' ? '#d4edda' : value?.userType == 'teacher' ? '#f8cfcf' : '#c4e1ea';
                                    const isFile = value?.messageType === 'FILE';
                                    const isImage = isFile && /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(value?.message || '');
                                    const isVideo = isFile && /\.(mp4|mov|webm)(\?.*)?$/i.test(value?.message || '');
                                    const isPdf = isFile && /\.pdf(\?.*)?$/i.test(value?.message || '');
                                    return (
                                        <>
                                          <div
                                              key={index}
                                              style={{
                                                backgroundColor: color,
                                                padding: '10px',
                                                marginBottom: '10px',
                                                borderRadius: '8px',
                                                float: float,
                                                clear: 'both',
                                              }}
                                              className='msg-bubble'
                                          >
                                            {value?.userType == 'admin' && (
                                                <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#155724', marginBottom: '4px' }}>Admin</div>
                                            )}
                                            <div>
                                              {isFile ? (
                                                  isImage ? (
                                                      <div
                                                          title={value.fileName || 'attachment'}
                                                          style={ATTACHMENT_THUMB_STYLE}
                                                          onClick={() => this.setState({ attachmentPreview: { url: value.message, type: 'image', name: value.fileName || 'attachment' } })}
                                                      >
                                                        <img src={value.message} alt={value.fileName || 'attachment'} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                                      </div>
                                                  ) : isVideo ? (
                                                      <div
                                                          title={value.fileName || 'video attachment'}
                                                          style={ATTACHMENT_THUMB_STYLE}
                                                          onClick={() => this.setState({ attachmentPreview: { url: value.message, type: 'video', name: value.fileName || 'video attachment' } })}
                                                      >
                                                        <video src={value.message} preload="metadata" muted style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                                        <span style={ATTACHMENT_PLAY_BADGE_STYLE}>
                                                          <i className="fa fa-play" />
                                                        </span>
                                                      </div>
                                                  ) : isPdf ? (
                                                      <div
                                                          title={value.fileName || 'PDF attachment'}
                                                          style={{ ...ATTACHMENT_THUMB_STYLE, ...ATTACHMENT_FILE_THUMB_STYLE }}
                                                          onClick={() => this.setState({ attachmentPreview: { url: value.message, type: 'pdf', name: value.fileName || 'PDF attachment' } })}
                                                      >
                                                        <i className="fa fa-file-pdf" style={{ fontSize: '34px', color: '#d93025' }} />
                                                        <span style={ATTACHMENT_THUMB_LABEL_STYLE}>{value.fileName || 'PDF'}</span>
                                                      </div>
                                                  ) : (
                                                      <a href={value.message} target="_blank" rel="noopener noreferrer" style={{ fontWeight: 'bold', color: '#212529', textDecoration: 'underline' }}>
                                                        <i className="fa fa-paperclip" style={{ marginRight: '6px' }} />
                                                        {value.fileName || 'Attachment'}
                                                      </a>
                                                  )
                                              ) : (
                                                  <span style={{fontWeight: 'bold', fontStyle: 'initial', fontSize: 'large'}}>{value.message}</span>
                                              )}
                                            </div>
                                            <div style={{ marginTop: '5px' }}>
                                              <span>{moment(value.createdAt).format(dateForPaymentListing)}</span>
                                              <span>&nbsp;{moment(value.createdAt).format(databaseTimeFormat)}</span>
                                            </div>
                                          </div>
                                        </>
                                    )
                                  })
                              }
                            </div>
                            {selectedMessageId && (
                                <div className='msg-composer' style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '10px 4px 4px', borderTop: '1px solid #e9ecef' }}>
                                  <input
                                      type="file"
                                      accept="image/jpeg,image/png,image/gif,image/webp,application/pdf,video/mp4,video/quicktime,video/webm"
                                      style={{ display: 'none' }}
                                      ref={(el) => { this.sectionChatFileInput = el; }}
                                      onChange={this.sendSectionChatFile}
                                  />
                                  <Button
                                      size="sm"
                                      type="button"
                                      title="Attach image or PDF"
                                      disabled={this.state.sectionChatSending}
                                      onClick={() => this.sectionChatFileInput && this.sectionChatFileInput.click()}
                                  >
                                    <i className="fa fa-paperclip" />
                                  </Button>
                                  <Input
                                      type="text"
                                      placeholder="Type a message..."
                                      value={this.state.sectionChatText}
                                      onChange={(e) => this.setState({ sectionChatText: e.target.value })}
                                      onKeyDown={(e) => { if (e.key === 'Enter') this.sendSectionChatMessage(); }}
                                      style={{ flex: 1 }}
                                  />
                                  <Button
                                      color="primary"
                                      size="sm"
                                      type="button"
                                      disabled={this.state.sectionChatSending || !(this.state.sectionChatText || '').trim()}
                                      onClick={this.sendSectionChatMessage}
                                  >
                                    {this.state.sectionChatSending ? 'Sending...' : 'Send'}
                                  </Button>
                                </div>
                            )}
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Row>
                </Container>
            </TabPane>
            <TabPane tabId='3'>
                <Container fluid>
                  <Row >
                    <div className='col'>
                      <Card className='shadow' >
                        <CardHeader className='border-0'>
                          <h3 className='mb-0'>Send Message</h3>
                        </CardHeader>
                        <div className="row">
                        <div className="col-lg-6">
                          <FormGroup className="availability-formgroup">
                            <InputGroup className="input-group-alternative">
                              <div style={{ width: "100%", minWidth: "200px" }}>
                                <Select
                                    style={{ width: "100%", minWidth: "200px" }}
                                    options={[
                                      ...(classList &&
                                          classList.map((item) => ({
                                            value: item.classId,
                                            label: item.name,
                                          }))),
                                    ]}
                                    placeholder="Select Class"
                                    onChange={(e) =>
                                        this.setState({ classId: e.value }, () => {
                                          this.getAllSections()
                                        })
                                    }
                                    isSearchable={true}
                                />
                              </div>
                            </InputGroup>
                          </FormGroup>

                          { sectionList && sectionList.length > 0 && (
                              <FormGroup className="availability-formgroup">
                                <InputGroup className="input-group-alternative">
                                  <div style={{ width: "100%", minWidth: "200px", marginTop: '20px' }}>
                                    <Select
                                        style={{ width: "100%", minWidth: "200px" }}
                                        options={[
                                          ...(sectionList &&
                                              sectionList.map((item) => ({
                                                value: item.sectionId,
                                                label: item.name,
                                              }))),
                                        ]}
                                        placeholder="Select Section"
                                        onChange={(e) =>
                                            this.setState({ sectionId: e.value }, () => {
                                              this.setSectionDetail()
                                            })
                                        }
                                        isSearchable={true}
                                    />
                                  </div>
                                </InputGroup>
                              </FormGroup>
                          )}

                          {
                            mobileNumber && (
                                <>
                                <div style={{marginTop: '20px'}}>
                                </div>
                                  <FormGroup>
                                    <InputGroup>
                                      <div style={{width: "100%"}}>
                                        <Input
                                            placeholder='Mobile Number'
                                            type='text'
                                            name='className'
                                            value={mobileNumber}
                                            style={{ width: '100%'}}
                                            onChange={(e) => {this.setState({mobileNumber: e.target.value})}}
                                        ></Input>
                                      </div>
                                    </InputGroup>
                                  </FormGroup>
                                </>
                              )
                          }

                          {
                            email && (
                                  <FormGroup>
                                    <InputGroup >
                                      <div style={{width: "100%"}}>
                                        <Input
                                            placeholder='Email'
                                            type='text'
                                            name='className'
                                            value={email}
                                            style={{ width: '100%'}}
                                            onChange={(e) => {this.setState({email: e.target.value})}}
                                        >
                                        </Input>
                                      </div>
                                    </InputGroup>
                                  </FormGroup>
                              )
                          }
                          {
                              email && (
                                  <>
                                    <FormGroup >
                                      <InputGroup>
                                        <div style={{width: "100%"}}>
                                          <Input
                                              placeholder='Email Subject'
                                              type='text'
                                              name='className'
                                              style={{ width: '100%'}}
                                              value={subject}
                                              onChange={(e) => {this.setState({subject: e.target.value})}}
                                          >
                                          </Input>
                                        </div>
                                      </InputGroup>
                                    </FormGroup>
                                    <FormGroup >
                                      <InputGroup >
                                        <div style={{width: "100%"}}>
                                          <textarea
                                              placeholder='Email Content'
                                              rows={5}
                                              name='className'
                                              style={{ width: '100%'}}
                                              onChange={(e) => {this.setState({emailContent: e.target.value})}}
                                          >
                                          </textarea>
                                        </div>
                                      </InputGroup>
                                    </FormGroup>
                                    <FormGroup >
                                        <InputGroup >
                                            <div   >
                                              <Button
                                                  color='primary'
                                                  type='button'
                                                  onClick={() => this.sendMessageByText()}
                                                >
                                                  Send Message
                                                </Button>
                                            </div>
                                        </InputGroup>
                                    </FormGroup>
                                  </>
                                )
                            }
                        </div>
                          <div className="col-lg-6" style={{marginTop: '10px'}}>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </Row>
                </Container>
            </TabPane>
            <TabPane tabId='4'>
                <Container fluid>
                  <Row >
                    <div className='col'>
                      <Card className='shadow' >
                        <CardHeader className='border-0'>
                          <h3 className='mb-0'>Voice Message</h3>
                        </CardHeader>
                        <CardBody>

                          <Table
                              className='align-items-center table-flush cp;'
                              responsive
                              style={{ marginBottom: '100px' }}
                          >
                            <thead className='thead-light'>
                            <tr>
                              <th scope='col'></th>
                              <th scope='col'>Mobile Number</th>
                              <th scope='col'>Audio</th>
                              <th scope='col'>Link</th>
                              <th scope='col'>Status</th>
                              <th scope='col'>Time</th>

                              {/*<th scope='col'>Notification Sent</th>*/}
                              <th scope='col' />
                            </tr>
                            </thead>
                            <tbody>
                            {voiceMessageList &&
                                voiceMessageList.map((value, index) => {
                                  const isActive = Object.values(this.state.messageStates).some(
                                      state => state === 'Connecting' || state === 'On call'
                                  )
                                  const userStateForMessage = this.state.messageStates[index] || USER_STATE.OFFLINE;
                                  return (
                                      value.isActive && (
                                          <tr key={index}>
                                            <td  className={'table-column-width'} >
                                              {
                                                (userStateForMessage === 'Connecting' || userStateForMessage === 'On call') ? (
                                                    <button
                                                        className={'btn btn-danger'}
                                                        onClick={() => this.rejectCall(value.mobile)}
                                                    >Reject
                                                    </button>
                                                ): (
                                                    <button
                                                        className={'btn btn-white'}
                                                        disabled={isActive}
                                                        onClick={() =>this.callInit(value, index)}
                                                    ><i className="fa fa-phone" style={{fontSize:'20px'}} ></i>
                                                    </button>
                                                )
                                              }
                                              <button onClick={() => this.clientConnect(index)} className={'btn btn-white'}>
                                                <i className="fa fa-comments" style={{fontSize:'20px'}} aria-hidden="true" ></i>
                                              </button>
                                            </td>
                                            <td className={'table-column-width'}>
                                              {value.mobile && (
                                                  <a href={"tel:" + value.mobile}>{value.mobile}</a>
                                              )}{" "}
                                            </td>
                                            <td  className={'table-column-width'}>
                                              {
                                                value.fileName ? (
                                                    <AudioPlayer
                                                        autoPlay={false}
                                                        autoPlayAfterSrcChange={false}
                                                        src={value.fileName}
                                                        onPlay={e => console.log("onPlay")}
                                                        // other props here
                                                    />
                                                ): (
                                                    <></>
                                                )
                                              }
                                            </td>
                                            <td className={'table-column-width'}>
                                                {
                                                  value.fileName ? (
                                                      <CopyToClipboard text={value.fileName}>
                                                        <i
                                                            style={{cursor: 'pointer'}}
                                                            className='BtnFill'
                                                            color='success'
                                                        ><i className='fa fa-copy'></i>
                                                        </i>
                                                      </CopyToClipboard>
                                                  ):(
                                                      <></>
                                                  )
                                                }
                                            </td>
                                            <td className={'table-column-width'}>
                                              {value.callStatus && (
                                                  <span>{value.callStatus}</span>
                                              )}{" "}
                                            </td>
                                            <td  className={'table-column-width'}>
                                              <Media className='align-items-center'>
                                                <Media>
                                                  <span className='mb-0 text-sm'>
                                                    {value.createdAt
                                                        ? moment(value.createdAt).format('ll hh:mm A')
                                                        : ''}
                                                  </span>
                                                </Media>
                                              </Media>
                                            </td>
                                          </tr>
                                      )
                                  );
                                })}
                            </tbody>
                          </Table>

                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
            </TabPane>

          </TabContent>


          {/* For notification modal */}
          <Modal
            className='modal-dialog-centered'
            isOpen={this.state.successModal || this.state.errorModal}
            toggle={() =>
              successModal
                ? this.toggleModal('successModal')
                : errorModal
                ? this.toggleModal('errorModal')
                : null
            }
          >
            <div className='modal-header'>
              <h5 className='modal-title' id='successModalLabel'>
                {modalTitle}
              </h5>
              <button
                aria-label='Close'
                className='close'
                data-dismiss='modal'
                type='button'
                onClick={() =>
                  successModal
                    ? this.toggleModal('successModal')
                    : errorModal
                    ? this.toggleModal('errorModal')
                    : null
                }
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            {this.state.successModal ? (
              <div className='modal-body' style={{ color: 'green' }}>
                {message}
              </div>
            ) : this.state.errorModal ? (
              <div className='modal-body' style={{ color: 'red' }}>
                {message}
              </div>
            ) : null}
            <div className='modal-footer'>
              <Button
                color='primary'
                type='button'
                onClick={() =>
                  successModal
                    ? this.toggleModal('successModal')
                    : errorModal
                    ? this.toggleModal('errorModal')
                    : null
                }
              >
                Ok
              </Button>
            </div>
          </Modal>
          <Modal
              className='modal-dialog-centered'
              size='lg'
              isOpen={notificationCallModal}
              toggle={() =>
                  this.toggleModal('notificationCallModal')
              }
          >
            <div className='modal-body p-0'>
              <Card className='bg-secondary shadow border-0'>
                <CardHeader className='bg-transparent pb-5'>
                  <div className='text-muted text-center'>
                    <small>{'Message'}</small>
                  </div>
                </CardHeader>
                <CardBody className='px-lg-5 py-lg-5'>
                  <Form role='form'>
                    <FormGroup >
                      <InputGroup className='input-group-alternative'>
                                       <textarea
                                           placeholder='Enter Message'
                                           cols={100}
                                           rows={5}
                                           value={twillioMessage}
                                           onChange={(e) =>
                                               this.setState({ twillioMessage: e.target.value })
                                           }
                                       />
                      </InputGroup>
                    </FormGroup>

                    <div className="row text-right">
                      <div className="ml-auto" style={{marginRight: '10px'}}>
                        <Button
                            color="primary"
                            type="button"
                            onClick={() => this.setState({ notificationCallModal: !notificationCallModal })}
                        >
                          Cancel
                        </Button>
                        <Button
                            disabled={!!loading}
                            color="primary"
                            type="button"
                            onClick={() => this.replyMessageResponses()}
                        >
                          Send Message
                        </Button>
                      </div>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </Modal>
          {this.state.attachmentPreview && (
              <div
                  onClick={() => this.setState({ attachmentPreview: null })}
                  style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.8)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
              >
                <span
                    role="button"
                    aria-label="Close preview"
                    style={{ position: 'absolute', top: '10px', right: '22px', color: '#fff', fontSize: '34px', lineHeight: 1, cursor: 'pointer' }}
                >
                  &times;
                </span>
                {this.state.attachmentPreview.type === 'image' ? (
                    <img
                        src={this.state.attachmentPreview.url}
                        alt={this.state.attachmentPreview.name}
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: '92vw', maxHeight: '92vh', borderRadius: '8px', boxShadow: '0 4px 30px rgba(0,0,0,0.5)' }}
                    />
                ) : this.state.attachmentPreview.type === 'video' ? (
                    <video
                        src={this.state.attachmentPreview.url}
                        controls
                        autoPlay
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: '92vw', maxHeight: '92vh', borderRadius: '8px', boxShadow: '0 4px 30px rgba(0,0,0,0.5)' }}
                    />
                ) : (
                    <iframe
                        src={this.state.attachmentPreview.url}
                        title={this.state.attachmentPreview.name}
                        onClick={(e) => e.stopPropagation()}
                        style={{ width: '92vw', height: '92vh', border: 'none', borderRadius: '8px', background: '#fff' }}
                    />
                )}
              </div>
          )}
      </div>
    );
  }
}

export default Message;
